export default {"src":"/_next/static/media/HeLa.38aa8d5f.svg","height":217,"width":679,"blurWidth":0,"blurHeight":0};